<!-- FERIADOS BANCARIOS (1.6a, Mario 08-oct-2026): los días en que no se paga. La fecha de pago al comercio
     pasa al hábil siguiente cuando el contrato dice «hábil siguiente». Estilo de la casa: kb-card, kb-table,
     kb-badge; el principal en negro. La baja se confirma en la misma fila.
     Calendario (Mario, 08-oct): pestañas Año · Mes · Lista; clic en un día = ver el feriado o dejar lista su carga. -->
<div class="kb-page kb-liq">

  <nav class="kb-migas" aria-label="Migas">
    <a class="kb-miga" routerLink="/console/parametros-sistema">Parámetros del sistema</a>
    <i class="fas fa-chevron-right kb-miga-sep" aria-hidden="true"></i>
    <a class="kb-miga" routerLink="/console/parametros-sistema/liquidacion">Liquidación a comercios</a>
    <i class="fas fa-chevron-right kb-miga-sep" aria-hidden="true"></i>
    <span class="kb-miga-actual">Feriados bancarios</span>
  </nav>

  <div class="kb-page-header">
    <div class="max-w-[720px]">
      <h1 class="kb-page-title">Feriados bancarios</h1>
      <p class="kb-page-meta">Los días en que no se paga a los comercios. Si la fecha de pago cae en fin de semana o en
        uno de estos días y el contrato dice «hábil siguiente», el pago pasa al primer día hábil.</p>
    </div>
    <span class="kb-badge kb-badge-neutro shrink-0" *ngIf="!puedeCargar && !puedeBorrar" title="Los mantiene la gerente de finanzas"><i class="fas fa-eye" aria-hidden="true"></i>Solo lectura</span>
    <div class="!flex !flex-row !flex-nowrap items-center gap-2 shrink-0 self-start !w-auto" role="group" aria-label="Año">
      <button type="button" class="kb-btn kb-btn-outline kb-btn-sm !w-auto" (click)="cambiarAnio(-1)" aria-label="Año anterior">
        <i class="fas fa-chevron-left !text-muted-foreground" aria-hidden="true"></i>
      </button>
      <span class="text-base font-semibold tabular-nums text-foreground min-w-[48px] text-center">{{ anio }}</span>
      <button type="button" class="kb-btn kb-btn-outline kb-btn-sm !w-auto" (click)="cambiarAnio(1)" aria-label="Año siguiente">
        <i class="fas fa-chevron-right !text-muted-foreground" aria-hidden="true"></i>
      </button>
    </div>
  </div>

  <div class="kb-aviso kb-aviso-peligro" *ngIf="error" role="alert">
    <i class="fas fa-exclamation-circle mt-0.5" aria-hidden="true"></i><div><p class="m-0">{{ error }}</p></div>
  </div>
  <div class="kb-cinta kb-cinta-info" *ngIf="aviso" role="status">
    <i class="fas fa-check-circle kb-cinta-icono" aria-hidden="true"></i><span>{{ aviso }}</span>
  </div>

  <div class="kb-tabs-list" role="tablist" aria-label="Vista">
    <button type="button" role="tab" class="kb-pestana" [class.kb-pestana-activa]="vista === 'anio'" [attr.aria-selected]="vista === 'anio'" (click)="vista = 'anio'">Año</button>
    <button type="button" role="tab" class="kb-pestana" [class.kb-pestana-activa]="vista === 'mes'" [attr.aria-selected]="vista === 'mes'" (click)="vista = 'mes'">Mes</button>
    <button type="button" role="tab" class="kb-pestana" [class.kb-pestana-activa]="vista === 'lista'" [attr.aria-selected]="vista === 'lista'" (click)="vista = 'lista'">Lista</button>
  </div>

  <!-- ══ Año: los doce meses ═══════════════════════════════════════════════ -->
  <section class="kb-card" *ngIf="vista === 'anio'" aria-labelledby="frTituloAnio">
    <div class="kb-card-header">
      <div>
        <h2 id="frTituloAnio" class="kb-card-title">Calendario {{ anio }}</h2>
        <p class="kb-card-desc">{{ feriados.length }} {{ feriados.length === 1 ? 'feriado' : 'feriados' }} · {{ proximos.length }} por venir. Toca un día para ver su feriado o cargar uno; toca el nombre del mes para verlo en grande.</p>
      </div>
    </div>
    <div class="kb-card-body flex flex-col gap-[20px]">
      <p class="kb-hint m-0" *ngIf="cargando">Cargando los feriados…</p>
      <div class="grid grid-cols-1 gap-x-[32px] gap-y-[28px] sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        <div class="min-w-0" *ngFor="let m of mesesDelAnio">
          <button type="button" class="mb-[8px] text-sm font-semibold capitalize text-foreground hover:underline" (click)="verMes(m.mes0)">{{ m.nombre }}</button>
          <table class="w-full table-fixed border-collapse text-center text-xs tabular-nums">
            <thead><tr><th class="pb-[4px] font-normal uppercase text-muted-foreground" *ngFor="let d of DIAS">{{ d.charAt(0) }}</th></tr></thead>
            <tbody>
              <tr *ngFor="let s of m.semanas">
                <td class="p-[1px]" *ngFor="let c of s">
                  <button type="button" *ngIf="c.delMes" (click)="elegirDia(c.dia)"
                    class="mx-auto flex h-[28px] w-[28px] items-center justify-center rounded-md transition-colors hover:bg-muted"
                    [ngClass]="{
                      'bg-foreground text-background hover:!bg-foreground/80': feriadoDe(c.dia) && !feriadoDe(c.dia).por_confirmar,
                      'border-[1.5px] border-dashed border-foreground bg-muted': feriadoDe(c.dia)?.por_confirmar,
                      'text-muted-foreground': !feriadoDe(c.dia) && finDeSemana(c.dia),
                      'font-bold underline decoration-2 underline-offset-[3px]': c.hoy,
                      'ring-2 ring-offset-1 ring-foreground': diaElegido === c.dia
                    }"
                    [attr.aria-label]="fecha(c.dia) + (feriadoDe(c.dia) ? ': ' + feriadoDe(c.dia).name : '')"
                    [attr.title]="feriadoDe(c.dia)?.name || null">{{ c.n }}</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <p class="kb-hint m-0 flex flex-wrap items-center gap-x-[16px] gap-y-[6px]">
        <span class="inline-flex items-center gap-[6px]"><span class="inline-block h-[12px] w-[12px] rounded-sm bg-foreground"></span>feriado</span>
        <span class="inline-flex items-center gap-[6px]"><span class="inline-block h-[12px] w-[12px] rounded-sm border-[1.5px] border-dashed border-foreground bg-muted"></span>por confirmar con el banco</span>
        <span class="inline-flex items-center gap-[6px]"><span class="font-bold text-foreground underline decoration-2 underline-offset-[3px]">8</span>hoy</span>
        <span>los sábados y domingos van atenuados: tampoco se paga</span>
      </p>
    </div>
  </section>

  <!-- ══ Mes: uno en grande, navegable ═════════════════════════════════════ -->
  <section class="kb-card" *ngIf="vista === 'mes'" aria-labelledby="frTituloMes">
    <div class="kb-card-header !items-center">
      <h2 id="frTituloMes" class="kb-card-title capitalize">{{ nombreMes }}</h2>
      <div class="!flex !flex-row !flex-nowrap items-center gap-2 shrink-0 !w-auto" role="group" aria-label="Mes">
        <button type="button" class="kb-btn kb-btn-outline kb-btn-sm !w-auto" (click)="moverMes(-1)" aria-label="Mes anterior"><i class="fas fa-chevron-left !text-muted-foreground" aria-hidden="true"></i></button>
        <button type="button" class="kb-btn kb-btn-outline kb-btn-sm !w-auto" (click)="moverMes(1)" aria-label="Mes siguiente"><i class="fas fa-chevron-right !text-muted-foreground" aria-hidden="true"></i></button>
      </div>
    </div>
    <div class="w-full overflow-x-auto">
      <table class="kb-table min-w-[640px] table-fixed">
        <thead class="kb-thead"><tr><th class="kb-th" *ngFor="let d of DIAS">{{ d }}</th></tr></thead>
        <tbody>
          <tr class="kb-tr" *ngFor="let s of semanasMes">
            <td class="kb-td h-[88px] cursor-pointer align-top hover:bg-muted/40" *ngFor="let c of s" (click)="elegirDia(c.dia)"
                [ngClass]="{ 'bg-muted/40': diaElegido === c.dia }">
              <p class="m-0 flex items-center gap-[6px] text-xs"
                 [ngClass]="!c.delMes ? 'text-muted-foreground/60' : finDeSemana(c.dia) ? 'text-muted-foreground' : 'font-medium text-foreground'">
                {{ c.n }}<span class="kb-badge kb-badge-neutro !py-0" *ngIf="c.hoy">hoy</span></p>
              <p class="m-0 mt-[8px] rounded-md px-[8px] py-[4px] text-xs leading-snug" *ngIf="feriadoDe(c.dia)"
                 [ngClass]="feriadoDe(c.dia).por_confirmar ? 'border border-dashed border-foreground text-foreground' : 'bg-foreground text-background'">
                {{ feriadoDe(c.dia)?.name }}</p>
              <p class="m-0 mt-[4px] text-[11px] text-muted-foreground" *ngIf="feriadoDe(c.dia)?.por_confirmar">por confirmar</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>

  <!-- ══ El día elegido (Año y Mes) ════════════════════════════════════════ -->
  <div class="kb-tira" *ngIf="diaElegido && vista !== 'lista'" role="status">
    <ng-container *ngIf="feriadoDe(diaElegido) as f">
      <div class="flex min-w-0 flex-col gap-[4px]">
        <p class="m-0 text-sm font-semibold text-foreground">{{ fecha(f.date) }} · {{ f.name }}</p>
        <p class="m-0 text-xs text-muted-foreground">{{ f.scope === 'NACIONAL' ? 'Nacional' : 'Bancario' }} · {{ f.por_confirmar ? 'por confirmar con el banco' : 'confirmado' }}{{ finDeSemana(f.date) ? ' · cae en fin de semana: no mueve ningún pago' : '' }}</p>
      </div>
      <div class="flex items-center gap-2">
        <button type="button" class="kb-btn kb-btn-ghost kb-btn-sm !w-auto" *ngIf="puedeBorrar && confirmandoBaja !== f._id" (click)="confirmandoBaja = f._id">
          <i class="fas fa-trash-alt !text-muted-foreground" aria-hidden="true"></i>Dar de baja</button>
        <ng-container *ngIf="puedeBorrar && confirmandoBaja === f._id">
          <span class="text-xs text-muted-foreground">¿Dejar de contarlo?</span>
          <button type="button" class="kb-btn kb-btn-outline kb-btn-sm !w-auto" (click)="confirmandoBaja = null" [disabled]="borrando">No</button>
          <button type="button" class="kb-btn kb-btn-danger kb-btn-sm !w-auto" (click)="darDeBaja(f)" [disabled]="borrando">{{ borrando ? 'Dando de baja…' : 'Sí, dar de baja' }}</button>
        </ng-container>
      </div>
    </ng-container>
    <p class="m-0 text-sm text-foreground" *ngIf="!feriadoDe(diaElegido)">
      El {{ fecha(diaElegido) }} no es feriado{{ finDeSemana(diaElegido) ? ' (es fin de semana: ya no se paga)' : '' }}.<ng-container *ngIf="puedeCargar"> Lo dejé listo abajo, en «Cargar un feriado»: falta el nombre.</ng-container></p>
  </div>

  <!-- ══ Lista del año ══════════════════════════════════════════════════════ -->
  <section class="kb-card" *ngIf="vista === 'lista'" aria-labelledby="frTituloLista">
    <div class="kb-card-header">
      <div>
        <h2 id="frTituloLista" class="kb-card-title">Feriados de {{ anio }}</h2>
        <p class="kb-card-desc" *ngIf="!cargando">
          {{ feriados.length }} {{ feriados.length === 1 ? 'cargado' : 'cargados' }} · {{ proximos.length }} por venir
          <ng-container *ngIf="porConfirmar"> · {{ porConfirmar }} por confirmar con el banco</ng-container>
        </p>
      </div>
    </div>

    <p class="kb-hint px-6 pb-6" *ngIf="cargando">Cargando los feriados…</p>
    <p class="kb-hint px-6 pb-6" *ngIf="!cargando && !error && !feriados.length">
      No hay feriados cargados para {{ anio }}. Mientras no se carguen, sólo los fines de semana mueven la fecha de pago.
    </p>

    <div class="kb-table-envoltorio" *ngIf="!cargando && feriados.length">
      <table class="kb-table">
        <thead class="kb-thead">
          <tr>
            <th class="kb-th w-[170px]">Fecha</th>
            <th class="kb-th">Feriado</th>
            <th class="kb-th w-[140px]">Alcance</th>
            <th class="kb-th w-[160px]">Estado</th>
            <th class="kb-th kb-th-acciones"><span class="sr-only">Acciones</span></th>
          </tr>
        </thead>
        <tbody>
          <tr class="kb-tr" *ngFor="let f of feriados" [class.opacity-60]="f.date < hoy()">
            <td class="kb-td kb-td-titulo tabular-nums">{{ fecha(f.date) }}</td>
            <td class="kb-td">
              {{ f.name }}
              <div class="kb-td-sub" *ngIf="finDeSemana(f.date)">Cae en fin de semana: no mueve ningún pago</div>
            </td>
            <td class="kb-td"><span class="kb-badge kb-badge-neutro">{{ f.scope === 'NACIONAL' ? 'Nacional' : 'Bancario' }}</span></td>
            <td class="kb-td">
              <span class="kb-badge kb-badge-alerta" *ngIf="f.por_confirmar">Por confirmar</span>
              <span class="kb-badge kb-badge-exito" *ngIf="!f.por_confirmar">Confirmado</span>
            </td>
            <td class="kb-td kb-td-acciones kb-acciones-grupo">
              <ng-container *ngIf="puedeBorrar && confirmandoBaja !== f._id">
                <button type="button" class="kb-btn kb-btn-ghost kb-btn-sm" (click)="confirmandoBaja = f._id"
                        [attr.aria-label]="'Dar de baja ' + f.name">
                  <i class="fas fa-trash-alt !text-muted-foreground" aria-hidden="true"></i>Dar de baja
                </button>
              </ng-container>
              <div class="flex items-center justify-end gap-2" *ngIf="puedeBorrar && confirmandoBaja === f._id">
                <span class="text-xs text-muted-foreground">¿Dejar de contarlo?</span>
                <button type="button" class="kb-btn kb-btn-outline kb-btn-sm" (click)="confirmandoBaja = null"
                        [disabled]="borrando">No</button>
                <button type="button" class="kb-btn kb-btn-danger kb-btn-sm" (click)="darDeBaja(f)" [disabled]="borrando">
                  {{ borrando ? 'Dando de baja…' : 'Sí, dar de baja' }}
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>

  <!-- ══ Cargar uno ═════════════════════════════════════════════════════════ -->
  <section class="kb-card" *ngIf="puedeCargar" aria-labelledby="frTituloNuevo">
    <div class="kb-card-header">
      <div>
        <h2 id="frTituloNuevo" class="kb-card-title">Cargar un feriado</h2>
        <p class="kb-card-desc">Cuenta desde que se guarda para las fechas de pago que todavía no se calcularon.</p>
      </div>
    </div>
    <form class="kb-card-body space-y-4" (ngSubmit)="guardar()">
      <div class="grid grid-cols-1 gap-4 sm:grid-cols-[180px_minmax(0,1fr)_180px]">
        <div>
          <label class="kb-label" for="frFecha">Fecha <span class="text-destructive">*</span></label>
          <input id="frFecha" name="frFecha" type="date" class="kb-input" [(ngModel)]="nuevo.date">
        </div>
        <div>
          <label class="kb-label" for="frNombre">Nombre <span class="text-destructive">*</span></label>
          <input id="frNombre" name="frNombre" type="text" class="kb-input" maxlength="80"
                 placeholder="Por ejemplo: Día de la Resistencia Indígena" [(ngModel)]="nuevo.name">
        </div>
        <div>
          <label class="kb-label" for="frAlcance">Alcance</label>
          <div class="kb-select-envoltorio">
            <select id="frAlcance" name="frAlcance" class="kb-select" [(ngModel)]="nuevo.scope">
              <option value="BANCARIO">Bancario</option>
              <option value="NACIONAL">Nacional</option>
            </select>
            <i class="fas fa-chevron-down kb-select-flecha" aria-hidden="true"></i>
          </div>
        </div>
      </div>
      <p class="kb-hint" *ngIf="nuevo.date && finDeSemana(nuevo.date)">Esa fecha cae en fin de semana: se guarda, pero no mueve ningún pago.</p>
      <p class="kb-error" *ngIf="errorGuardar" role="alert">{{ errorGuardar }}</p>
      <div class="flex flex-wrap items-center justify-end gap-3">
        <span class="kb-hint m-0" *ngIf="errores.length && (nuevo.date || nuevo.name)">{{ errores.join(' · ') }}</span>
        <button type="submit" class="kb-btn kb-btn-primary !bg-foreground !text-background hover:!bg-foreground/90"
                [disabled]="guardando || errores.length > 0">
          <i class="fas fa-plus" aria-hidden="true"></i>{{ guardando ? 'Guardando…' : 'Cargar feriado' }}
        </button>
      </div>
    </form>
  </section>
</div>
